import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Wrapper from './Wrapper';



function App() {
  return (
    <div className="App">     
      <Wrapper />
    </div>
  );
}

export default App;
